module.exports = __webpack_public_path__ + "img/gtm.4e57fe45.webp";